import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import {
    radiusSelector,
    locationSelector,
    propertyTypeSelector,
    isTravelTimeSearchSelector,
    durationSelector,
    transportTypeSelector
} from '../../reducers/filters';
import {
    StyledIcon,
    MobileQuickSearchBarWrapper,
    Wrapper,
    Divider,
    StyledLocationText,
    StyledRadiusText
} from './MobileQuickSearchButton.styles';
import { Text } from '@blueprint/ui';

import { trackQuickSearchButtonClick } from './MobileQuickSearchButton.tracking';
import { ModalTypes } from '../../shared/components/ModalManager/ModalManager.types';
import { useSelectBedsTitle } from 'search/hooks/useSelectBedsTitle';
import { useSelectPriceTitle } from 'search/hooks/useSelectPriceTitle';

const durationOptionsText: { [key: string]: string } = {
    '900': '15 minutes',
    '1800': '30 minutes',
    '2700': '45 minutes',
    '3600': '1 hour',
    '4500': '1 ¼ hour'
};
const transportTypeOptionsText: { [key: string]: string } = {
    driving: 'Driving',
    walking: 'Walking',
    walking_train: 'Train',
    public_transport: 'Public transport',
    cycling: 'Cycling'
};

export type Props = {
    openModal: (type: ModalTypes) => void;
};

export const MobileQuickSearchButton: FC<Props> = ({ openModal }) => {
    const {
        selectedValue: radiusSelectedValue,
        options: radiusOptions
    } = useSelector(radiusSelector);

    const {
        selectedValue: propertySelectedValue,
        options: propertyTypeOptions
    } = useSelector(propertyTypeSelector);

    const radiusLabel = radiusOptions.find((option) => {
        if (radiusSelectedValue !== '') {
            return option.value === radiusSelectedValue;
        }
        return radiusOptions[0];
    })?.label;

    const propertyTypeLabel = propertyTypeOptions.find(
        (option) => option.value === propertySelectedValue
    )?.label;

    const { selectedValue: locationSelectedValue } = useSelector(
        locationSelector
    );

    const isTravelTimeSearch = useSelector(isTravelTimeSearchSelector);

    const selectBedsTitle = useSelectBedsTitle();
    const selectPriceTitle = useSelectPriceTitle();

    const {
        selectedValue: durationValue,
        options: durationOptions
    } = useSelector(durationSelector);

    const {
        selectedValue: transportTypeSelectedValue,
        options: transportTypeOptions
    } = useSelector(transportTypeSelector);

    const durationTitleDisplay =
        durationOptionsText[durationValue || durationOptions[0].value];

    const travelTypeDurationType =
        transportTypeOptionsText[
            transportTypeSelectedValue || transportTypeOptions[0].value
        ];
    const title = `${durationTitleDisplay} • ${travelTypeDurationType}`;

    return (
        <>
            <Wrapper
                onClick={() => {
                    openModal('search_initiation');
                    trackQuickSearchButtonClick();
                }}
                data-testid="testid_quick_search_modal_button"
            >
                <MobileQuickSearchBarWrapper>
                    <StyledIcon
                        iconId="searchsuggest"
                        strokeColor="icon-dark"
                        color="icon-dark"
                        size="small"
                    />
                    <Text color="text-body">
                        <StyledLocationText color="text-title">
                            {locationSelectedValue}
                        </StyledLocationText>
                        <StyledRadiusText>
                            <Divider />
                            {!isTravelTimeSearch
                                ? `${radiusLabel}`
                                : `${title}`}
                        </StyledRadiusText>
                        <Divider />
                        {selectBedsTitle}
                        <Divider />
                        {selectPriceTitle}
                        <Divider />
                        {propertyTypeLabel}
                    </Text>
                </MobileQuickSearchBarWrapper>
            </Wrapper>
        </>
    );
};
